import React from 'react';

import {
  applyTheme,
  readThemePreference,
  writeThemePreference,
  type ThemePreference
} from '~/lib/theme';

/**
 * The theme preference and a setter that applies and persists it.
 *
 * Reads on mount rather than at module load so a component rendered in a test,
 * or after the preference changed in another tab, starts from what is actually
 * stored. Following the OS on "auto" is the app root's job, not this hook's --
 * the OS can change while nothing is mounted here.
 */
export const useThemePreference = (): [ThemePreference, (next: ThemePreference) => void] => {
  const [preference, setPreference] = React.useState<ThemePreference>(readThemePreference);

  const update = React.useCallback((next: ThemePreference) => {
    writeThemePreference(next);
    applyTheme(next);
    setPreference(next);
  }, []);

  return [preference, update];
};
